import { ClassTreeCommandType } from '../../enums/custom-class-tree/class-tree-operation.enum';
import { TranslationCodeView } from '../translation/TranslationCodeView';

export interface ClassTreeCommand {
  readonly type: ClassTreeCommandType;
}

export class ClassTreeMoveCommand implements ClassTreeCommand {
  readonly type: ClassTreeCommandType = ClassTreeCommandType.MOVE;
  constructor(
    public classIds: string[],
    public parentId: string,
    public placeBefore: string | null
  ) {}
}

export class ClassTreeDeleteCommand implements ClassTreeCommand {
  readonly type: ClassTreeCommandType = ClassTreeCommandType.DELETE;
  constructor(
    public classId: string,
    public parentId: string
  ) {}
}

export class ClassTreeRenameCommand implements ClassTreeCommand {
  readonly type: ClassTreeCommandType = ClassTreeCommandType.RENAME;
  constructor(
    public classId: string,
    public nameTranslation: TranslationCodeView
  ) {}
}
